export default function removeUrlParameter(url, parameter) {
  const urlParts = url.split('?');

  if (urlParts.length >= 2) {
    // Get first part, and remove from array
    const urlBase = urlParts.shift();

    // Join it back up
    const queryString = urlParts.join('?');

    const prefix = `${encodeURIComponent(parameter)}=`;
    const parts = queryString.split(/[&;]/g);

    // Reverse iteration as may be destructive
    // eslint-disable-next-line
    for (let i = parts.length; (i -= 1) >= 0;) {
      // Idiom for string.startsWith
      if (parts[i].lastIndexOf(prefix, 0) !== -1) {
        parts.splice(i, 1);
      }
    }

    url = `${urlBase}?${parts.join('&')}`;
  }

  return url;
}



// WEBPACK FOOTER //
// ./src/helper/helper.js